export default __webpack_public_path__ + "images/103414973fc58efb84d046f74b8749c4.png";